export enum ChangesGroupType {
  major = 'major',
  minor = 'minor'
}
